// Bypass Recharge account access link inject
// https://docs.rechargepayments.com/docs/translate-the-customer-account-access-link#bypass-account-access-link-inject

window.rcLoginAccessLink = {
  disableInjection: true
};
